import { getCoreMigrationsDir, getProjectMigrationsDir } from '@kernel/config/paths.js'
import { moduleStore } from '@kernel/engine/module-store.js'

/**
 * Migration source identifier.
 * - 'core': nexus-backend core modules
 * - 'plugin:{name}': plugin-owned migrations
 * - 'project': user project modules
 */
export type MigrationSourceId = 'core' | `plugin:${string}` | 'project'

/**
 * Describes a migration source with its directory and file prefix.
 */
export interface MigrationSourceDescriptor {
  id: MigrationSourceId
  dir: string
  /** File prefix for this source (e.g. 'core__', 'cms__', '' for project) */
  prefix: string
}

/**
 * Build ordered migration sources: core → plugins (topological) → project.
 * Each source has a directory and a file prefix for collision avoidance.
 */
export function buildMigrationSources(): MigrationSourceDescriptor[] {
  const sources: MigrationSourceDescriptor[] = [
    { id: 'core', dir: getCoreMigrationsDir(), prefix: 'core__' },
  ]

  for (const [name, plugin] of moduleStore.plugins) {
    if (!plugin.migrationsDir) continue
    sources.push({
      id: `plugin:${name}`,
      dir: plugin.migrationsDir,
      prefix: `${plugin.code}__`,
    })
  }

  sources.push({ id: 'project', dir: getProjectMigrationsDir(), prefix: '' })
  return sources
}

